export const LOGIN_AUTH_ERROR_QUERY_PARAM = 'authError';
export const LOGIN_AUTH_ERROR_ACCOUNT_NOT_ENABLED = 'account-not-enabled';
